var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#5CB335",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6628 19.1396C15.6628 16.9305 17.4537 15.1396 19.6628 15.1396H32.2576C33.3205 15.1396 34.3397 15.5627 35.0902 16.3154L42.4334 23.6804C43.181 24.4302 43.6008 25.4458 43.6008 26.5046V40.8594C43.6008 43.0685 41.81 44.8594 39.6008 44.8594H19.6628C17.4537 44.8594 15.6628 43.0685 15.6628 40.8594V19.1396Z",
    stroke: "#5AAD46",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2278 15.1396V22.458C33.2278 24.6671 35.0186 26.458 37.2278 26.458H44.3372",
    stroke: "#5AAD46",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8974 39.3435C25.2824 39.3435 24.7724 38.8335 24.7724 38.2185V31.9335L23.6924 33.0135C23.2574 33.4485 22.5374 33.4485 22.1024 33.0135C21.6674 32.5785 21.6674 31.8585 22.1024 31.4235L25.1024 28.4235C25.4174 28.1085 25.9124 28.0035 26.3324 28.1835C26.7524 28.3485 27.0224 28.7685 27.0224 29.2185V38.2185C27.0224 38.8335 26.5124 39.3435 25.8974 39.3435Z",
    fill: "#5AAD46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8974 33.3439C28.6124 33.3439 28.3274 33.2389 28.1024 33.0139L25.1024 30.0139C24.6674 29.5789 24.6674 28.8589 25.1024 28.4239C25.5374 27.9889 26.2574 27.9889 26.6924 28.4239L29.6924 31.4239C30.1274 31.8589 30.1274 32.5789 29.6924 33.0139C29.4674 33.2389 29.1824 33.3439 28.8974 33.3439Z",
    fill: "#5AAD46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadSquareIcon);
export default __webpack_public_path__ + "static/media/file-upload-square-icon.e40c037c494af1375713ca8ae31ba2e2.svg";
export { ForwardRef as ReactComponent };